import { CsvButton } from '@components/Buttons/CsvButton';
import { LinkText } from '@components/LinkText';
import { DataTable } from '@components/Table/DataTable';
import { Pagination } from '@components/Table/Pagination';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { TableSortCell } from '@components/Table/TableSortCell';
import { TableSortRow } from '@components/Table/TableSortRow';
import { useCellPopover } from '@hooks/useCellPopover';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import IFatura, { useFaturaTipoColor } from '@model/Fatura';
import { useFaturaStatusColor } from '@model/FaturaStatus';
import { IFaturaFilter } from '@services/Relatorios/RelatorioFaturaService';
import React from 'react';

export type FaturaTableProps = {
    data: IData<IFatura, IFaturaFilter>
    isLoading: boolean
    onCsvButtonClick: VoidFunction
}

export function FaturaTable ({ data, onCsvButtonClick, isLoading }: FaturaTableProps) {
    const formatter = useFormatter();
    const faturaStatusColor = useFaturaStatusColor();
    const faturaTipoColor = useFaturaTipoColor();
    const cellPopover = useCellPopover<IFatura>();

    return (
        <DataTable 
            isLoading={isLoading} 
            itemCount={data.itemsCount}
        >
            <TableHead>
                <Pagination pagination={data.pagination}>
                    <CsvButton onClick={onCsvButtonClick} disabled={isLoading} />
                </Pagination>

                <TableSortRow sort={data.sort}>
                    <TableSortCell fieldName="faturaId">ID</TableSortCell>
                    <TableSortCell fieldName="clienteNome">Cliente</TableSortCell>
                    <TableSortCell fieldName="empresaNome">Empresa</TableSortCell>
                    <TableSortCell fieldName="dataVencimento">Vencimento</TableSortCell>
                    <TableSortCell fieldName="valorTotal">Vlr. Total</TableSortCell>
                    <TableSortCell fieldName="valorPago">Vlr. Pago</TableSortCell>
                    <TableSortCell fieldName="saldo">Saldo</TableSortCell>
                    <TableSortCell fieldName="dataPagamento">Pagamento</TableSortCell>
                    <TableSortCell fieldName="formaPagamentoNome">Forma Pgto.</TableSortCell>
                    <TableSortCell fieldName="tipo">Tipo</TableSortCell>
                    <TableSortCell fieldName="faturaStatusNome">Status</TableSortCell>
                </TableSortRow>
            </TableHead>
            
            <TableBody>
                {
                    data.items.map((fatura, index) => {
                        return (
                            <TableRow key={index}>
                                <TableKeyCell>{fatura.faturaId}</TableKeyCell>
                                <TableCell><LinkText to={`/cliente/${fatura.clienteId}`} text={fatura.clienteNome} /></TableCell>
                                <TableCell>{fatura.empresaNome}</TableCell>
                                <TableCell>{formatter.toDate(fatura.dataVencimento)}</TableCell>
                                <TableCell>{formatter.toFloat(fatura.valorTotal)}</TableCell>
                                <TableCell>{formatter.toFloat(fatura.valorPago)}</TableCell>
                                <TableCell>{formatter.toFloat(fatura.saldo)}</TableCell>
                                <TableCell>{formatter.toDate(fatura.dataPagamento)}</TableCell>
                                <TableCell>{fatura.formaPagamentoNome}</TableCell>
                                
                                <TableCell className={faturaTipoColor[fatura.tipo]}>
                                    { fatura.tipo }
                                </TableCell>

                                <TableCell 
                                    className={faturaStatusColor[fatura.faturaStatusId]}
                                    onMouseEnter={cellPopover.handleMouseOpen(fatura)}
                                    onMouseLeave={cellPopover.close}
                                >
                                    { fatura.faturaStatusNome }
                                </TableCell>
                            </TableRow>
                        )
                    })
                }

                <Pagination pagination={data.pagination}>
                    <CsvButton onClick={onCsvButtonClick} disabled={isLoading} />
                </Pagination>
            </TableBody>
        </DataTable>
  )
}